const makeClamper = ({ min, max }) => value =>
  value < min ? min : value > max ? max : value;

const clampRadialNumber = makeClamper({ min: 0, max: 360 });
const clampDecimalNumber = makeClamper({ min: 0, max: 1 });

export default function makeHSL({ hue, saturation, lightness, opacity } = {}) {
  const parameters = [
    clampRadialNumber(hue || 0),
    `${clampDecimalNumber(saturation || 0) * 100}%`,
    `${clampDecimalNumber(lightness || 1) * 100}%`,
    `${clampDecimalNumber(opacity || 1)}`,
  ];

  return `hsl(${parameters.join(', ')})`;
}
